import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Product } from 'omni-package-react-core';
import { StyledText, StyledIcon, StyledSpan } from './Content.styles';

export interface ContentProps {
  product: Product;
}

const Content: FC<ContentProps> = ({ product }) => {
  const { t } = useTranslation('MyProductsTile');

  return (
    <>
      <StyledIcon $clickable={product.isClickable} />
      <StyledText>{t('contractNumberLabel')} </StyledText>
      <StyledSpan>{product.normalizedContractNumber}</StyledSpan>
    </>
  );
};
export default Content;
